
// import React, { useState } from 'react';
// import data from '../../data/home2/projects';

// function Projects() {
//   const [activeFilter, setActiveFilter] = useState('all');

//   const filterProjects = (category) => {
//     if (category === 'all') return data;
//     return data.filter(item => item.category === category);
//   };

//   const filteredData = filterProjects(activeFilter);

//   return (
//     <section className="tc-projects-style2">
//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-lg-8">
//             <h2 className="fsz-45 fw-500">
//               Latest{' '}
//               <span className="sub-font fst-italic color-orange1 fw-400">
//                 projects
//               </span>
//             </h2>
//           </div>
//           <div className="col-lg-4 text-lg-end mt-4 mt-lg-0">
//             <a
//               href="/portfolio"
//               className="butn borderd border rounded-pill hover-bg-black"
//             >
//               <span>
//                 See All Projects
//                 <i className="ms-2 fal fa-long-arrow-right ico-45"></i>
//               </span>
//             </a>
//           </div>
//         </div>
//         <div className="tabs-links mt-40">
//           <ul className="nav nav-pills" id="pills-tab" role="tablist">
//             <li className="nav-item" role="presentation">
//               <button
//                 className={`nav-link ${activeFilter === 'all' ? 'active' : ''}`}
//                 onClick={() => setActiveFilter('all')}
//                 type="button"
//               >
//                 All Projects
//               </button>
//             </li>
//             <li className="nav-item" role="presentation">
//               <button
//                 className={`nav-link ${activeFilter === 'completed' ? 'active' : ''}`}
//                 onClick={() => setActiveFilter('Facade System')}
//                 type="button"
//               >
//                 Completed Projects
//               </button>
//             </li>
//             <li className="nav-item" role="presentation">
//               <button
//                 className={`nav-link ${activeFilter === 'ongoing' ? 'active' : ''}`}
//                 onClick={() => setActiveFilter('Facade Solutions')}
//                 type="button"
//               >
//                 Ongoing Projects
//               </button>
//             </li>
//             <li className="nav-item" role="presentation">
//               <button
//                 className={`nav-link ${activeFilter === 'upcoming' ? 'active' : ''}`}
//                 onClick={() => setActiveFilter('Partitions')}
//                 type="button"
//               >
//                 Upcoming Projects
//               </button>
//             </li>
//           </ul>
//         </div>
//       </div>
//       <div className="tab-content" id="pills-tabContent">
//         <div className="tab-pane fade show active">
//           <div className="projects-slider-content mt-100">
//             <div className="projects-slider">
//               <div className="swiper-wrapper">
//                 {filteredData.map((item, i) => (
//                   <div key={i} className="swiper-slide">
//                     <div className="project-card">
//                       <a href="#" className="img">
//                         <img src={item.img} alt="" className="img-cover" />
//                         <div className="year">
//                           <span className="txt"> {item.year}</span>
//                           <img
//                             src="/home2/assets/img/project_shape.png"
//                             alt=""
//                             className="bg"
//                           />
//                         </div>
//                         <div className="arrow">
//                           <i className="fal fa-long-arrow-right ico-45"></i>
//                         </div>
//                       </a>
//                       <div className="info">
//                         <h3 className="title">
//                           <a href="#"> {item.title} </a>
//                           <p className='fsz-20'>{item.contract}</p>
//                         </h3>
//                         <div className="project-details">
//                           {item.sub1 && <p className="detail-item">{item.sub1}</p>}
//                           {item.sub2 && <p className="detail-item">{item.sub2}</p>}
//                           {item.sub3 && <p className="detail-item">{item.sub3}</p>}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               <div className="controls">
//                 <div className="container">
//                   <div className="swiper-pagination"></div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default Projects;



'use client';
import React, { useState } from 'react';
import data from '../../data/home2/projects';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function Projects() {
  const [activeFilter, setActiveFilter] = useState('all');

  // Filter projects by status
  const filteredData =
    activeFilter === 'all'
      ? data
      : data.filter((item) => item.category === activeFilter);

  return (
    <section className="tc-projects-style2">
      <div className="container">
        {/* Header */}
        <div className="row align-items-center">
          <div className="col-lg-8">
            <h2 className="fsz-45 fw-500">
              Latest{' '}
              <span className="sub-font fst-italic color-orange1 fw-400">
                projects
              </span>
            </h2>
          </div>
          <div className="col-lg-4 text-lg-end mt-4 mt-lg-0">
            <a
              href="/portfolio"
              className="butn borderd border rounded-pill hover-bg-black"
            >
              <span>
                See All Projects
                <i className="ms-2 fal fa-long-arrow-right ico-45"></i>
              </span>
            </a>
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="tabs-links mt-40">
          <ul className="nav nav-pills" id="pills-tab" role="tablist">
            {['all', 'completed', 'ongoing', 'upcoming'].map((filter) => (
              <li className="nav-item" key={filter}>
                <button
                  className={`nav-link ${
                    activeFilter === filter ? 'active' : ''
                  }`}
                  onClick={() => setActiveFilter(filter)}
                  type="button"
                >
                  {filter === 'all'
                    ? 'All Projects'
                    : `${filter.charAt(0).toUpperCase() + filter.slice(1)} Projects`}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Swiper Section */}
      <div className="tab-content" id="pills-tabContent">
        <div className="tab-pane fade show active">
          <div className="projects-slider-content mt-100">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={3}
              navigation
              pagination={{ clickable: true }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              breakpoints={{
                320: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {filteredData.map((item, i) => (
                <SwiperSlide key={i}>
                  <div className="project-card">
                    <a href="#" className="img">
                      <img src={item.img} alt={item.title} className="img-cover" />
                      <div className="year">
                        <span className="txt">{item.year}</span>
                        <img
                          src="/home2/assets/img/project_shape.png"
                          alt=""
                          className="bg"
                        />
                      </div>
                      <div className="arrow">
                        <i className="fal fa-long-arrow-right ico-45"></i>
                      </div>
                    </a>
                    <div className="info">
                      <h3 className="title">
                        <a href="#"> {item.title} </a>
                      </h3>
                      <p>{item.contract}</p>
                      <div className="project-details">
                        {item.sub1 && <p className="detail-item">{item.sub1}</p>}
                        {item.sub2 && <p className="detail-item">{item.sub2}</p>}
                        {item.sub3 && <p className="detail-item">{item.sub3}</p>}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Projects;
